import React, { ReactElement } from "react";
import styled from "styled-components";
import { Typography, Modal, theme } from "antd";

interface DefaultModalProps extends React.PropsWithChildren {
  theme: "primary" | "success" | "danger" | "default";
  title: string;
  onCancel(): void;
  isShow: boolean;
  children: ReactElement;
}

const DefaultModal: React.FC<DefaultModalProps> = ({
  title,
  isShow = false,
  onCancel,
  children
}) => {
  return (
    <StyledModal
      theme={theme}
      open={isShow}
      title={title}
      onCancel={onCancel}
      cancelButtonProps={{ style: { display: "none" } }}
      okButtonProps={{ style: { display: "none" } }}
    >
      <StyledModalBody>{children}</StyledModalBody>
    </StyledModal>
)};

export default DefaultModal;

const StyledModal = styled(Modal)`
    .ant-modal-content {
      padding: 0;

      .ant-modal-close {
        color: #fff;
      }

      .ant-modal-header {
        padding: 1rem;
        background: #02488D;

        .ant-modal-title {
          color: #fff;
          text-align: center;
        }
      }

      .ant-modal-body {
        padding: 1rem 2rem 1.5rem;
      }
    }
`

const StyledModalBody = styled(Typography.Paragraph)`
    text-align: center;
    color: #02488D;
`